import React from "react";

import { Tooltip } from "@material-ui/core";
import { orange, red } from "@material-ui/core/colors";

import { AccountType, ExternalStatus } from "../../../utils/constants";
import {
  BrokeredAccountIcon,
  InternalAccountIcon,
  InvoicesIcon,
  OverdueIcon,
} from "../../../components/common/iconography";
import { ExternalStatusIcon } from "../../../components/common/ExternalStatusIcon";

export const AccountStatusIcon = ({ record }) => {
  if (!record?.status && !record?.externalStatus) return null;

  if (
    record?.externalStatus &&
    record.externalStatus !== ExternalStatus.SYNCED
  ) {
    return <ExternalStatusIcon record={record} />;
  }

  if (record?.overLimit) {
    return (
      <Tooltip title="Over Credit Limit" placement="right" arrow>
        <InvoicesIcon style={{ color: red[700] }} />
      </Tooltip>
    );
  }
  if (record?.overDue) {
    return (
      <Tooltip title="Over Due" placement="right" arrow>
        <OverdueIcon style={{ color: orange[700] }} />
      </Tooltip>
    );
  }
  if (record?.accountType === AccountType.INTERNAL) {
    return (
      <Tooltip title="Internal Account" placement="right" arrow>
        <InternalAccountIcon record={record} />
      </Tooltip>
    );
  }
  if (record?.accountType === AccountType.BROKERED) {
    return (
      <Tooltip title="Brokered Account" placement="right" arrow>
        <BrokeredAccountIcon record={record} />
      </Tooltip>
    );
  }

  return null;
};
